import IntegrationPathnames from "./constants/integration-pathnames";
import IntegrationNames from "./constants/integration-names";

const getIntegrationPathname = ({ name }) => {
  if (name === IntegrationNames[name.toUpperCase()]) {
    return IntegrationPathnames[name.toUpperCase()];
  }
};

export default getIntegrationPathname;
